<template>
  <div
    class="likes"
    @click="handleClick"
  >
    <k-icon
      :icon="iconData.icon"
      :class="isLiked ? 'filled' : ''"
    />
    <span class="number">
      {{likes}}
    </span>
  </div>
</template>

<script>
import KIcon from './KIcon.vue';

export default {
  name: 'Like',
  components: {
    KIcon
  },
  props: {
    liked: {
      type: Boolean,
      default: false
    },
    likes: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconData () {
      if (this.isLiked) return {
        icon: 'heart-filled',
      }
      return {
        icon: 'heart',
      }
    }
  },
  data () {
    return {
      isLiked: false
    }
  },
  created () {
    this.isLiked = this.liked
  },
  methods: {
    handleClick () {
      this.isLiked = !this.isLiked
      if (this.liked) this.$emit('unlike')
      else this.$emit('like')
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.likes {
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  .filled {
    color: #ff6362;
  }
  .number {
    @include body-5;
    color: lighten($neutral-1, 50%);
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/kaledo-components/src/components/Like.vue